import styled from 'styled-components';
//@ts-ignore
import Loader from '@mindtickle/loader';
//@ts-ignore
import { tokens } from '@mindtickle/styles/lib';

const StyledAuthLoader = styled(Loader)`
  background: ${tokens.bgTokens.COLOR_BG_DEFAULT} !important;
  .loader-wrp {
    width: 64px;
    height: 78px;
  }
`;

export default StyledAuthLoader;
